/**
 * Business-relevant validation error codes tracked in canonical logs.
 * Format in canonical: `${assetType}:${code}` (e.g., 'background_image:DIMENSIONS_TOO_SMALL')
 */
export const VALIDATION_CODES = {
  DIMENSIONS_TOO_SMALL: 'DIMENSIONS_TOO_SMALL',
  DIMENSIONS_TOO_LARGE: 'DIMENSIONS_TOO_LARGE',
  WRONG_ASPECT_RATIO: 'WRONG_ASPECT_RATIO',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  INVALID_JPEG_TYPE: 'INVALID_JPEG_TYPE',
  INVALID_BASELINE_JPEG: 'INVALID_BASELINE_JPEG',
  VIDEO_TOO_SHORT: 'VIDEO_TOO_SHORT',
  VIDEO_TOO_LONG: 'VIDEO_TOO_LONG',
} as const;

export const BUSINESS_VALIDATION_CODES: string[] = Object.values(VALIDATION_CODES);
